import {getToken} from './getToken';

export const addAuthToken = (getState, dispatch, config) =>
  getToken({getState, dispatch}).then(token => {
    if (!config.headers) {
      config.headers = {};
    }
    config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  });
